module.exports = __webpack_public_path__ + "img/10trebol.19635027.png";